var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.right_add") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutters" },
            [_c("back-button")],
            1
          ),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("administration.right"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start" },
                _vm._l(_vm.rights_list, function (right, index) {
                  return _c(
                    "b-col",
                    {
                      key: index,
                      staticClass: "form-group",
                      attrs: { sm: "4" },
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: { value: 1, "unchecked-value": 0 },
                          model: {
                            value: _vm.rightList[right],
                            callback: function ($$v) {
                              _vm.$set(_vm.rightList, right, $$v)
                            },
                            expression: "rightList[right]",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("rights.db_rights." + right) ===
                                  "rights.db_rights." + right
                                  ? right
                                  : _vm.$t("rights.db_rights." + right)
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass:
                "accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters",
            },
            [
              _c(
                "b-button",
                { attrs: { variant: "primary" }, on: { click: _vm.addRight } },
                [
                  _c("i", { staticClass: "fa-light fa-add" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("common.add_label")))]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }